import API from "../../utils/endpoints";
import history from "../../history";
import * as types from "./actionType";
import { toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
const errorMessage = {
  status: 400,
  message: "Something went wrong",
};

function uploadUrlRequest() {
  return {
    type: types.UPLOAD_URL,
  };
}

function uploadUrlSuccess(payload) {
  return {
    type: types.UPLOAD_URL_SUCCESS,
    payload,
  };
}

function uploadUrlFailed() {
  return {
    type: types.UPLOAD_URL_FAILED,
  };
}

function readUrlRequest() {
  return {
    type: types.READ_URL,
  };
}

function readUrlSuccess(payload) {
  return {
    type: types.READ_URL_SUCCESS,
    payload,
  };
}

function readUrlFailed() {
  return {
    type: types.READ_URL_FAILED,
  };
}

function uploadBinaryUrlRequest() {
  return {
    type: types.UPLOAD_BINARY_URL,
  };
}

function uploadBinaryUrlSuccess(payload) {
  return {
    type: types.UPLOAD_BINARY_URL_SUCCESS,
    payload,
  };
}

function uploadBinaryUrlFailed() {
  return {
    type: types.UPLOAD_BINARY_URL_FAILED,
  };
}

function uploadGalleryUrlRequest() {
  return {
    type: types.UPLOAD_GALLERY_URL,
  };
}

function uploadGalleryUrlSuccess(payload) {
  return {
    type: types.UPLOAD_GALLERY_URL_SUCCESS,
    payload,
  };
}

function uploadGalleryUrlFailed() {
  return {
    type: types.UPLOAD_GALLERY_URL_FAILED,
  };
}

function readGalleryUrlRequest() {
  return {
    type: types.READ_GALLERY_URL,
  };
}

function readGalleryUrlSuccess(payload) {
  return {
    type: types.READ_GALLERY_URL_SUCCESS,
    payload,
  };
}

function readGalleryUrlFailed() {
  return {
    type: types.READ_GALLERY_URL_FAILED,
  };
}

function uploadGalleryBinaryUrlRequest() {
  return {
    type: types.UPLOAD_GALLERY_BINARY_URL,
  };
}

function uploadGalleryBinaryUrlSuccess(payload) {
  return {
    type: types.UPLOAD_GALLERY_BINARY_URL_SUCCESS,
    payload,
  };
}

function uploadGalleryBinaryUrlFailed() {
  return {
    type: types.UPLOAD_GALLERY_BINARY_URL_FAILED,
  };
}

function uploadVideoUrlRequest() {
  return {
    type: types.UPLOAD_VIDEO_URL,
  };
}

function uploadVideoUrlSuccess(payload) {
  return {
    type: types.UPLOAD_VIDEO_URL_SUCCESS,
    payload,
  };
}

function uploadVideoUrlFailed() {
  return {
    type: types.UPLOAD_VIDEO_URL_FAILED,
  };
}

function readVideoUrlRequest() {
  return {
    type: types.READ_VIDEO_URL,
  };
}

function readVideoUrlSuccess(payload) {
  return {
    type: types.READ_VIDEO_URL_SUCCESS,
    payload,
  };
}

function readVideoUrlFailed() {
  return {
    type: types.READ_VIDEO_URL_FAILED,
  };
}

function uploadVideoBinaryUrlRequest() {
  return {
    type: types.UPLOAD_VIDEO_BINARY_URL,
  };
}

function uploadVideoBinaryUrlSuccess(payload) {
  return {
    type: types.UPLOAD_VIDEO_BINARY_URL_SUCCESS,
    payload,
  };
}

function uploadVideoBinaryUrlFailed() {
  return {
    type: types.UPLOAD_VIDEO_BINARY_URL_FAILED,
  };
}

export function clearingPreviousReducer() {
  return {
    type: types.CLEAR_PREVIOUS_REDUCERS,
  };
}

export const uploadUrl = (payload, callback, category) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(uploadUrlRequest());
  try {
    let response = await api.post(API.uploadUrl, {
      name: payload.name,
      extension: payload.type.slice(payload.type.lastIndexOf("/") + 1),
      category: category,
    });
    if (response.data.code === 200) {
      dispatch(uploadUrlSuccess(response.data.data));
      dispatch(uploadBinaryUrl(response.data.data, payload, callback));
    } else {
      dispatch(uploadUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(uploadUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const uploadBinaryUrl = (data, payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(uploadBinaryUrlRequest());
  try {
    let response = await axios.put(data.uploadURL, payload, {
      headers: {
        "x-ms-blob-type": "BlockBlob",
      },
    });
    console.log("res", response.status);
    if (response.status === 201) {
      dispatch(uploadBinaryUrlSuccess(response.data.data));
      dispatch(readUrl(data.filePath, callback));
    } else {
      dispatch(uploadBinaryUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(uploadBinaryUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const readUrl = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(readUrlRequest());
  try {
    let response = await api.get(`${API.readUrl}?path=${payload}`);
    if (response.data.code === 200) {
      let prevData = getState().VinLookup.documentRead;
      let newData = [...prevData, response.data.data.blobPath];
      dispatch(readUrlSuccess(newData));
      callback && callback(response.data.data.blobPath);
    } else {
      dispatch(readUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(readUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const uploadGalleryUrl = (payload, callback, category) => async (
  dispatch,
  getState,
  api
) => {
  
  dispatch(uploadGalleryUrlRequest());
  try {
    let response = await api.post(API.uploadUrl, {
      name: payload.name,
      extension: payload.type.slice(payload.type.lastIndexOf("/") + 1),
      category: category,
    });
    console.log("da1")
    if (response.data.code === 200) {
      console.log("da")
      dispatch(uploadGalleryUrlSuccess(response.data.data));
      dispatch(uploadGalleryBinaryUrl(response.data.data, payload, callback));
    } else {
      dispatch(uploadGalleryUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(uploadGalleryUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const uploadGalleryBinaryUrl = (data, payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(uploadGalleryBinaryUrlRequest());
  try {
    let response = await axios.put(data.uploadURL, payload, {
      headers: {
        "x-ms-blob-type": "BlockBlob",
      },
    });
    console.log("res", response.status);
    if (response.status === 201) {
      dispatch(uploadGalleryBinaryUrlSuccess(response.data.data));
      dispatch(readGalleryUrl(data.filePath, callback));
    } else {
      dispatch(uploadGalleryBinaryUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(uploadGalleryBinaryUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const readGalleryUrl = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(readGalleryUrlRequest());
  try {
    let response = await api.get(`${API.readUrl}?path=${payload}`);
    if (response.data.code === 200) {
      let prevData = getState().VinLookup.documentRead;
      let newData = [...prevData, response.data.data.blobPath];
      dispatch(readGalleryUrlSuccess(newData));
      callback && callback(response.data.data.blobPath);
    } else {
      dispatch(readGalleryUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(readGalleryUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const uploadVideoUrl = (payload, callback, category) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(uploadVideoUrlRequest());
  try {
    let response = await api.post(API.uploadUrl, {
      name: payload.name,
      extension: payload.type.slice(payload.type.lastIndexOf("/") + 1),
      category: category,
    });
    if (response.data.code === 200) {
      dispatch(uploadVideoUrlSuccess(response.data.data));
      dispatch(uploadVideoBinaryUrl(response.data.data, payload, callback));
    } else {
      dispatch(uploadVideoUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(uploadVideoUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const uploadVideoBinaryUrl = (data, payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(uploadVideoBinaryUrlRequest());
  try {
    let response = await axios.put(data.uploadURL, payload, {
      headers: {
        "x-ms-blob-type": "BlockBlob",
      },
    });
    console.log("res", response.status);
    if (response.status === 201) {
      dispatch(uploadVideoBinaryUrlSuccess(response.data.data));
      dispatch(readVideoUrl(data.filePath, callback));
    } else {
      dispatch(uploadVideoBinaryUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(uploadVideoBinaryUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const readVideoUrl = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(readVideoUrlRequest());
  try {
    let response = await api.get(`${API.readUrl}?path=${payload}`);
    if (response.data.code === 200) {
      let prevData = getState().VinLookup.documentRead;
      let newData = [...prevData, response.data.data.blobPath];
      dispatch(readVideoUrlSuccess(newData));
      callback && callback(response.data.data.blobPath);
    } else {
      dispatch(readVideoUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(readVideoUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};
